module.exports = __webpack_public_path__ + "img/hint_icon.a3a39f00.svg";